import React, { createContext, useContext, useState, useCallback } from "react";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "ht", label: "Kreyòl" },
  { code: "es", label: "Español" },
];

const UI = {
  hubTitle: { en: "TAVEN Hub", fr: "TAVEN Hub", ht: "TAVEN Hub", es: "TAVEN Hub" },
  hubSubtitle: {
    en: "Every TAVEN service and portal in one place.",
    fr: "Tous les services et portails TAVEN en un seul endroit.",
    ht: "Tout sèvis ak pòtay TAVEN nan yon sèl kote.",
    es: "Todos los servicios y portales de TAVEN en un solo lugar.",
  },
  searchPlaceholder: {
    en: "Search features…", fr: "Rechercher des fonctionnalités…",
    ht: "Chèche fonksyon…", es: "Buscar funciones…",
  },
  comingSoon: { en: "Coming Soon", fr: "Bientôt", ht: "Byento", es: "Próximamente" },
  membersOnly: { en: "Members Only", fr: "Membres uniquement", ht: "Manm sèlman", es: "Solo miembros" },
  gated: { en: "Setup Pending", fr: "Config. en attente", ht: "Konfigirasyon annatant", es: "Configuración pendiente" },
  noResults: { en: "No features match your search.", fr: "Aucune fonctionnalité trouvée.", ht: "Pa gen fonksyon ki koresponn.", es: "No se encontraron funciones." },
  language: { en: "Language", fr: "Langue", ht: "Lang", es: "Idioma" },
  actions: {
    shop: { en: "Shop", fr: "Acheter", ht: "Achte", es: "Comprar" },
    open: { en: "Open", fr: "Ouvrir", ht: "Louvri", es: "Abrir" },
    explore: { en: "Explore", fr: "Explorer", ht: "Eksplore", es: "Explorar" },
    learn: { en: "Learn", fr: "Apprendre", ht: "Aprann", es: "Aprender" },
    track: { en: "Track", fr: "Suivre", ht: "Swiv", es: "Rastrear" },
    join: { en: "Join", fr: "Rejoindre", ht: "Antre", es: "Unirse" },
    start_selling: { en: "Start Selling", fr: "Vendre", ht: "Kòmanse Vann", es: "Vender" },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("taven_lang") || "en");
  const setLang = useCallback((code) => { setLangState(code); localStorage.setItem("taven_lang", code); }, []);
  // pick language from a {en,fr,ht,es} dict with english fallback
  const ml = useCallback((dict) => {
    if (!dict) return "";
    if (typeof dict === "string") return dict;
    return dict[lang] || dict.en || Object.values(dict)[0] || "";
  }, [lang]);
  const t = useCallback((key) => (UI[key] ? ml(UI[key]) : key), [ml]);
  const action = useCallback((key) => ml(UI.actions[key] || UI.actions.open), [ml]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, ml, t, action }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "en", setLang: () => {}, ml: (d) => (typeof d === "string" ? d : d?.en || ""), t: (k) => k, action: () => "Open" };
  return ctx;
};
